<template>
	<app-section :class="$attrs.class">
		<div class="flex items-center">
			<app-title title="Address" class="flex flex-1" />
		</div>
		<app-line />
		<p><span class="font-bold">Address: </span>{{ address.address }}</p>
		<p><span class="font-bold">Details: </span>{{ address.details }}</p>
	</app-section>
</template>

<script>
	export default {
		name: 'ShippingAddressDetails',
		props: {
			address: {
				required: true,
				type: Object,
			},
		},
		methods: {
			editAddress() {
				this.$emit('onAddressEdit');
			},
		},
	};
</script>
